import React, { useState } from "react";

interface SafeImageProps {
	src: string;
	alt: string;
	fallback?: React.ReactNode; // co pokazać jeśli obraz się nie załaduje
	className?: string;
	onLoadError?: (error: Event) => void;
	onLoadSuccess?: () => void;
}

export const SafeImage: React.FC<SafeImageProps> = ({
	src,
	alt,
	fallback = "📴",
	className = "",
	onLoadError,
	onLoadSuccess,
}) => {
	const [isLoaded, setIsLoaded] = useState(false);
	const [hasError, setHasError] = useState(false);

	const handleLoad = (): void => {
		setIsLoaded(true);
		setHasError(false);
		onLoadSuccess?.();
	};

	const handleError = (event: React.SyntheticEvent<HTMLImageElement, Event>): void => {
		console.warn(`[SafeImage] Failed to load image: ${src}`, event);
		setIsLoaded(false);
		setHasError(true);
		onLoadError?.(event.nativeEvent);
	};

	if (hasError) {
		return (
			<div className={`flex items-center justify-center ${className}`}>
				{typeof fallback === "string" ? (
					<div className="text-4xl">{fallback}</div>
				) : (
					fallback
				)}
			</div>
		);
	}

	return (
		<img
			src={src}
			alt={alt}
			className={className}
			onLoad={handleLoad}
			onError={handleError}
		/>
	);
};
